module.exports = __webpack_public_path__ + "img/pin-car.661884be.svg";